export default {
  'menu.welcome': 'Selamat Datang',
  'menu.entity': 'Entiti',
  'menu.more-blocks': 'Blok Lain',
  'menu.home': 'Laman Utama',
  'menu.admin': 'Pentadbir',
  'menu.admin.sub-page': 'Sub-Halaman',
  'menu.login': 'Log Masuk',
  'menu.register': 'Daftar',
  'menu.register-result': 'Keputusan Pendaftaran',
  'menu.dashboard': 'Papan Pemuka',
  'menu.dashboard.analysis': 'Aplikasi',
  'menu.dashboard.monitor': 'Pemantau',
  'menu.flow': 'Aliran',
  'menu.divider': 'Pembahagi',
  'menu.dashboard.workplace': 'Ruang Kerja',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Borang',
  'menu.form.basic-form': 'Borang Asas',
  'menu.form.step-form': 'Borang Berperingkat',
  'menu.form.step-form.info': 'Borang Berperingkat (isi maklumat pemindahan)',
  'menu.form.step-form.confirm': 'Borang Berperingkat (sahkan maklumat pemindahan)',
  'menu.form.step-form.result': 'Borang Berperingkat (selesai)',
  'menu.form.advanced-form': 'Borang Lanjutan',
  'menu.list': 'Senarai',
  'menu.list.table-list': 'Jadual Carian',
  'menu.list.basic-list': 'Senarai Asas',
  'menu.list.card-list': 'Senarai Kad',
  'menu.list.search-list': 'Senarai Carian',
  'menu.list.search-list.articles': 'Senarai Carian (artikel)',
  'menu.list.search-list.projects': 'Senarai Carian (projek)',
  'menu.list.search-list.applications': 'Senarai Carian (aplikasi)',
  'menu.profile': 'Profil',
  'menu.profile.basic': 'Profil Asas',
  'menu.profile.advanced': 'Profil Lanjutan',
  'menu.result': 'Keputusan',
  'menu.result.success': 'Berjaya',
  'menu.result.fail': 'Gagal',
  'menu.exception': 'Pengecualian',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Pencetus',
  'menu.account': 'Akaun',
  'menu.account.center': 'Pusat Akaun',
  'menu.account.settings': 'Tetapan Akaun',
  'menu.account.trigger': 'Cetus Ralat',
  'menu.account.logout': 'Log Keluar',
  'menu.editor': 'Penyunting Grafik',
  'menu.editor.flow': 'Penyunting Aliran',
  'menu.editor.mind': 'Penyunting Peta Minda',
  'menu.editor.koni': 'Penyunting Koni',
  'menu.user-management': 'Pengguna',
  'menu.tag-management': 'Tag',
  'menu.canned-response': 'Tersedia',
  'menu.chatrooms': 'Bilik Sembang',
  'menu.email': 'E-mel',
  'menu.core': 'Ciri Teras',
  'menu.files': 'Fail',
  'menu.filesNew': 'Fail (Baharu)',
  'menu.filesRefactored': 'Fail (Dirombak)',
  'menu.favouritesHub': 'Perkara',
  'menu.library': 'Pustaka Gesaan',
  'menu.chat': 'Sembang',
  'menu.search': 'Carian',
  'menu.specialised': 'Khusus',
  'menu.app': 'Aplikasi',
  'menu.playbook': 'Workstudio',
  'menu.template': 'Output Tersuai',
  'menu.quote': 'Sebut Harga',
  'menu.review': 'Semakan',
  'menu.sideBySide': 'Bersebelahan',
  'menu.grading': 'Penggredan',
  'menu.setting': 'Tetapan',
  'menu.diagnostics': 'Diagnosis',
  'menu.context': 'Konteks',
  'menu.management': 'Urus',
  'menu.conversation': 'Perbualan',
  'menu.translation': 'Terjemahan',
  'menu.broadcast': 'Siaran',
  'menu.dictionary': 'Kamus',
  'menu.question': 'Soalan',
  'menu.nlp': 'NLP',
  'menu.form.new-flow': 'Aliran Baharu',
  'menu.form.update-flow': 'Ubah Suai Aliran',
  'menu.list.flow-list': 'Senarai Aliran',
  'menu.comparison': 'Perbandingan',
  'menu.scribe': 'Scribe',
  'menu.organisation': 'Organisasi',
  'menu.superAdminOrganisation': 'Org Super Admin',
  'menu.section.vault': 'Peti Simpanan',
  'menu.section.chatAndCompose': 'Sembang & Karang',
  'menu.section.specialised': 'Khusus',
  'menu.section.system': 'Sistem',
};
